import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { useHasChildren } from 'bundles/project/hooks';

export default function Section({ children, label }) {
  const ref = useRef();
  const hasFields = useHasChildren(ref);

  return (
    <section className="mb-4" ref={ref}>
      {hasFields ? <h6 className="mb-2">{label}</h6> : null}
      {children}
    </section>
  );
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};
